import { useContext } from 'react';

import { AuthContext } from './context';
import type { AuthContextValue } from './types';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error('useAuth() must be used inside an <AuthProvider>.');
  }
  return ctx;
}
